import { Component, OnInit, AfterViewInit, OnDestroy, HostListener, ElementRef, ViewChild, ViewChildren } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { MatDialogRef, MatDialog } from '@angular/material';
import { NotificationService } from 'src/app/core/services/notification.service';
import { CommonService } from 'src/app/core/services/common.service';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { Message } from 'src/app/core/class/message';
import { UserService } from 'src/app/core/services/user.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { StorageService } from 'src/app/core/services/storage.service';

@Component({
  selector: 'change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {
  // Refer to form in view
  @ViewChild('f', { static: false }) ngForm: NgForm;
  // Subscribe to form changing
  formChangesSubscription: Subscription;
  // Whether the form change or not
  isFormChanging = false;
  checkEscKey = false;

  currentPasswordVisibility: boolean = false;
  newPasswordVisibility: boolean = false;
  confirmPasswordVisibility: boolean = false;

  passwordData = {
    currentPassword: null,
    newPassword: null,
    confirmPassword: null
  }
  isFocusNewPassword = false;

  strengthPattern = '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[~!@#$%^&*()_+|`={}[\\\]:<;?>,."\'/-]).{1,}$';

  @ViewChildren('focusInput') focusInput;

  userType: number;

  constructor(
    private userService: UserService,
    private el: ElementRef,
    public dialogRef: MatDialogRef<ChangePasswordComponent>,
    private dialog: MatDialog,
    public notificationService: NotificationService,
    public commonService: CommonService,
    public message: Message,
    private toastr: ToastrService,
    private router: Router,
    private auth: AuthenticationService,
    private storage: StorageService
  ) {
    super(commonService, message);
    dialogRef.disableClose = true;
    dialogRef.backdropClick().subscribe(_ => {
      this.cancel();
    });

    this.userType = storage.getUserTypeFromSessionStorage();
  }

  @HostListener('submit')
  onFormSubmit() {
    const invalidElements = this.el.nativeElement.querySelectorAll('.mat-form-field-invalid .mat-input-element,.mat-select-invalid');
    if (invalidElements.length > 0) {
      invalidElements[0].focus();
    }
  }

  @HostListener('document:keydown.escape', ['$event'])
  onKeydownHandler(event: KeyboardEvent) {
    if (!this.checkEscKey) {
      this.cancel();
    }
  }

  /**
   * On After Init
   */
  ngAfterViewInit() {
    setTimeout(_ => this.focusInput.first.nativeElement.focus(), 200);

    this.formChangesSubscription = this.ngForm.valueChanges.subscribe(() => {
      if (this.ngForm.dirty) {
        this.isFormChanging = true;
      }
    });
  }

  /**
   * Implement ngOnDestroy method, unsubscribe error service to avoid memory leak
   */
  ngOnDestroy() {
    this.formChangesSubscription.unsubscribe();
    this.notificationService.unsubscribeErrorService();
  }

  /**
   * Close pop-up
   */
  cancel() {
    if (this.isFormChanging) {
      this.checkEscKey = true;
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: 'messages.confirm_change_data'
      });
      dialogRe.afterClosed().subscribe(result => {
        if (result) {
          this.dialogRef.close();
        }
        dialogRe.close();
        this.checkEscKey = false;
      });
    } else {
      this.dialogRef.close();
    }
  }

  enableFocus = true;

  clickVisibility(){
    console.log("click")
    this.enableFocus = false;
    this.newPasswordVisibility = !this.newPasswordVisibility;
    setTimeout(() => {
      this.enableFocus = true;

    }, 700)
  }


  isTouch = false;

  onFocus(){
    this.isTouch = true;
    if(!this.enableFocus){
      return
    }
    console.log("focus")
    setTimeout(() => {
      this.isFocusNewPassword = true;
    }, 150)
  }

  onBlur(){
    if(!this.enableFocus){
      return
    }
    console.log("blur")
    setTimeout(() => {
      this.isFocusNewPassword = false;
    }, 150)
  }

  changePassword() {
    const dialog = this.dialog.open(WarningComponent, {
      width: "350px",
      data: this.message.getMessage("messages.confirm_change_password"),
    });
    dialog.afterClosed().subscribe((ref) => {
      if (ref) {
        this.userService.changePassword(this.passwordData).subscribe((rs) => {
          if (rs && rs.success) {

            localStorage.setItem("dayToExpire", rs.data.dayToExpire)
            localStorage.setItem("passwordExpired", rs.data.passwordExpired)
            this.toastr.success(
              this.message.getMessage("change_password.change_pass_success")
            );
            this.notificationService.emitChangePassword(true);
            this.dialogRef.close();
            //this.auth.logout();
          } else if (rs && !rs.success) {
            if (rs.code == "0x00126") {
              setTimeout(
                (_) => this.focusInput.first.nativeElement.focus(),
                200
              );
              this.toastr.error(
                this.message.getMessage("change_password.change_pass_error")
              );
            }
            if (rs.code == "0x00115") {
              setTimeout(
                (_) => this.focusInput.first.nativeElement.focus(),
                200
              );
              this.toastr.error(
                rs.data.newPassword
              );
            }
          }
        });
      }
    });
  }
}
